/**
 * Hiérarchie d'empilement POS — une seule source de vérité.
 * (Chrome page < panneau service < modales < confirmations)
 */
export const POS_Z_CLASS = {
  pageHeader: 'z-10',
  pageToolbar: 'z-20',
  serviceOverlay: 'z-40',
  modalBackdrop: 'z-50',
  modalConfirm: 'z-[70]',
  /** Aperçu duplicata au-dessus du détail ticket (z-50) */
  modalDuplicata: 'z-[60]',
};
